import { useContext } from 'react'
import { Link } from 'react-router-dom'
//Context
import { I18nContext } from '../context/I18nProvider'
import Translate from '../i18n/Translate'
import { useTranslation } from 'react-i18next'
//Components
import OperatorsGallery from '../components/OperatorsGallery'
import MiceCards from '../containers/Mice/MiceCards'
//Intersection
import { useInView } from 'react-intersection-observer'
//Hooks
import useScrollTop from '../hooks/useScrollTop'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'

const Mice = () => {
    useScrollTop()
    useSetI18nProviderInformation('mice')

    const { t } = useTranslation()
    const { language } = useContext(I18nContext)

    const [miceTop, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    const [miceText, inView2] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    })

    return (
        <main className="incoming-mice">
            <section className="incoming-mice__top">
                <div className={`content animate slide-title ${inView ? 'in-view' : ''}`} ref={miceTop}>
                    <h1 className="title top-title">
                        <Translate langkey="mice.title" />
                    </h1>
                    <p className="copy top-subtitle">
                        <Translate langkey="mice.subtitle" />
                    </p>
                </div>
            </section>

            <section className={`incoming-mice__text animate slide-up ${inView2 ? 'in-view' : ''}`} ref={miceText}>
                <h2 className="mice-title">
                    <Translate langkey="mice.text.title" />
                </h2>
                <div className="copy-container">
                    <p className="mice-copy text">
                        <Translate langkey="mice.text.copy" />
                    </p>
                    <h3 className="mice-copy subtitle">
                        <Translate langkey="mice.text.subtitle" />
                    </h3>
                    <ul className="mice-copy list">
                        <li>
                            <Translate langkey="mice.text.list.item1" />
                        </li>
                        <li>
                            <Translate langkey="mice.text.list.item2" />
                        </li>
                        <li>
                            <Translate langkey="mice.text.list.item3" />
                        </li>
                        <li>
                            <Translate langkey="mice.text.list.item4" />
                        </li>
                        <li>
                            <Translate langkey="mice.text.list.item5" />
                        </li>
                        <li>
                            <Translate langkey="mice.text.list.item6" />
                        </li>
                    </ul>
                    <Link to={`/${language}${t('routes.mice_contact')}`} className="button">
                        <span>
                            <Translate langkey="mice.text.button" />
                        </span>
                    </Link>
                </div>
            </section>

            <MiceCards />

            <OperatorsGallery />
        </main>
    )
}

export default Mice
